module.exports = __webpack_public_path__ + "static/media/Noannotationset.62b9f513.png";